/**
 * Created by jonas on 2021-03-04.
 */
import {DasUBootSymbol, DasUBootSymbolStates} from "../DasUBootSymbol";
import {gsap} from "gsap";
import {DasUBootReel} from "../DasUBootReel";
import {DasUBoot} from "../../DasUBoot";
import {DasUBootGameAssets} from "../../DasUBootGameAssets";
import {DasUBootSound} from "../../sound/DasUBootSound";
import {DasUBootStatics} from "../../utils/DasUBootStatics";

export function isMysterySymbol(value:any):value is MysterySymbol {
    return value.symbolName === "M" || value.symbolName === "MW";
}


export class MysterySymbol extends DasUBootSymbol {

    public subSymbols:DasUBootSymbol[] | undefined;
    private subSymbolContainer:PIXI.Container;
    public isRevealed:boolean = false;

    constructor(reel:DasUBootReel, symbolName:string) {
        super(reel, symbolName);

    }

    public getAvalancheScale() {
        if (this.subSymbols && this.subSymbols.length > 0) {
            return this.subSymbols[0].getAvalancheScale();
        }

        return this.resizeScale;
    }


    moveToWinLayer() {
        super.moveToWinLayer();
    }

    public addSubSymbols(symbols:DasUBootSymbol[]) {
        this.subSymbols = symbols;
        this.subSymbolContainer = new PIXI.Container();
        for (let symbol of this.subSymbols) {
            symbol.isSubSymbol = true;
            this.subSymbolContainer.addChild(symbol.view);
        }
        this.view.addChildAt(this.subSymbolContainer, 0);
    }

    protected getScaleYAnchor():number {
        return 1;
    }

    public resize(scale:number, offset:number, duration:number, customEase?:any):gsap.core.Timeline {
        customEase = customEase != undefined ? customEase : DasUBootStatics.xWayScaleEase;

        const tl = gsap.timeline();

        if (!this.isRevealed) {
            const overlay = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.getSymbolStateTexturePath(this.symbolName, "_big"))[0]);
            overlay.position.set(0, 144);
            overlay.anchor.set(0, 1);
            tl.add(() => {
                this.maskedView.addChild(overlay);
                this.sprite.tint = 0xff0000;
                this.sprite.alpha = 0;
            });

            tl.add(() => DasUBoot.soundPlayer.playSound(DasUBootSound.XWAY_RESCALE));
        }

        tl.add(super.resize(scale, offset, duration, customEase));

        if (this.subSymbols && this.subSymbols.length > 0) {
            const subScale = scale / this.subSymbols.length;
            for (let i:number = 0; i < this.subSymbols.length; i++) {
                const subSym = this.subSymbols[i];
                tl.add(subSym.resize(subScale, 144 * subScale * i, duration, customEase), "<");
            }
        }

        return tl;
    }


    public getStateAnimation(state:DasUBootSymbolStates):gsap.core.Timeline {
        let tl:gsap.core.Timeline = gsap.timeline();

        switch (state) {
            case DasUBootSymbolStates.WIN:
                tl.add(() => this.moveToWinLayer());
                break;
            case DasUBootSymbolStates.LANDING:
                tl = super.getStateAnimation(state);
                if (this.isVisibleInReel()) {
                    tl.add(() => DasUBoot.soundPlayer.playSingleSound(DasUBootSound.XWAY_LANDING));
                    tl.add(() => {DasUBoot.reelView.getLandingShake(false).play(0)});
                }
                break;
            case DasUBootSymbolStates.REVEAL:
                tl.add(() => this.setState(state, "none"));
                tl.add(this.getRevealAnimation());
                break;
            case DasUBootSymbolStates.NO_WIN:
                tl.add(() => this.setState(state));
                break;
            default:
                tl = super.getStateAnimation(state);


        }

        if (this.subSymbols) {
            for (let sub of this.subSymbols) {
                tl.add(sub.getStateAnimation(state), "<");
            }
        }

        this._stateAnimation = tl;
        return tl;
    }


    public getRevealAnimation():gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        if (this.isRevealed) {
            return tl;
        }

        this.isRevealed = true;
        const winFrame = this.getWinFrame(DasUBootStatics.mysteryRevealTint);
        tl.add(() => {this.view.addChild(winFrame)});
        tl.add(() => DasUBoot.soundPlayer.playSingleSound(DasUBootSound.XWAY_REVEAL));
        tl.add(winFrame.show(0.1));
        tl.add(winFrame.getAttention(true), "<");
        tl.add(gsap.to(this.maskedView, {
            duration:0.4,
            ease:"power2.out",
            pixi:{alpha:0, saturation:1.0, combineCMF:false, brightness:10}
        }), "-=0.45");
        tl.add(gsap.to(this.maskedView, {
            duration:0.2,
            ease:"power2.out",
            pixi:{alpha:0, saturation:1.0, combineCMF:false, brightness:0}
        }));
        tl.add(winFrame.hide(0.1), "-=0.1");
        return tl;
    }


    public playPeriscopePotentialWin():void {
        if (this.subSymbols) {
            for (let sym of this.subSymbols) {
                sym.playPeriscopePotentialWin();
            }

            this.moveToWinLayer();
        }
    }

    public stopPeriscopePotentialWin() {
        if (this.subSymbols) {
            for (let sym of this.subSymbols) {
                sym.stopPeriscopePotentialWin();
            }
            this.moveToNormalLayer();
        }
    }

    public playPotentialWinAttention():gsap.core.Timeline {
        const tl = gsap.timeline();
        if (this.subSymbols) {
            for (let sym of this.subSymbols) {
                tl.add(sym.playPotentialWinAttention(), 0);
            }
        }
        return tl;
    }


}